module.exports = __webpack_public_path__ + "img/add-photo-first-icon.ffbcd28a.svg";